export const FACEBOOK_CLIENT_ID = '819633338945558';

export const IMAGE_PLACEHOLDER = 'https://demofree.sirv.com/nope-not-here.jpg';

export const VIDEO_PLACEHOLDER = 'https://cdn.dribbble.com/users/2479503/screenshots/6402160/placeholder.png';

export const CHARGING_VIDEO = 'https://cdn.dribbble.com/users/537591/screenshots/3432519/media/2923d95487764533d00dfd70580b69a9.gif';


